// Replaces deprecated babel-polyfill with core-js 3 + regenerator-runtime.
// core-js provides polyfills for ECMAScript features (Promise, Array.from, etc.)
// regenerator-runtime provides support for async/await and generators.
// With @babel/preset-env useBuiltIns: 'entry', these imports are automatically
// replaced with only the polyfills needed for our browserslist targets.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Legacy compat: codebase uses .flatten() (old proposal name) instead of .flat().
// core-js 3 only polyfills .flat(), so alias .flatten() to .flat().
if (!Array.prototype.flatten) {
  Array.prototype.flatten = Array.prototype.flat;
}
